import { render, staticRenderFns } from "./material-master-data.vue?vue&type=template&id=3cb5d547&scoped=true"
import script from "./material-master-data.vue?vue&type=script&lang=js"
export * from "./material-master-data.vue?vue&type=script&lang=js"
import style0 from "./material-master-data.vue?vue&type=style&index=0&id=3cb5d547&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb5d547",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cb5d547')) {
      api.createRecord('3cb5d547', component.options)
    } else {
      api.reload('3cb5d547', component.options)
    }
    module.hot.accept("./material-master-data.vue?vue&type=template&id=3cb5d547&scoped=true", function () {
      api.rerender('3cb5d547', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/material/material-master-data/material-master-data.vue"
export default component.exports